import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/axios';

/**
 * Lite-User-Einstiegsseite: liest den eigenen Kontakt (genau 1) und
 * navigiert weiter zum bestehenden Kontakt-Detail mit Tracking-Tab.
 */
export default function LiteTracking() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    api.get('/contacts').then(({ data }) => {
      if (cancelled) return;
      const rows = data?.data ?? [];
      if (rows.length === 0) return;
      const first = rows[0];
      navigate(`/contacts/${first.id}?tab=tracking`, { replace: true });
    }).catch(() => { /* fallback bleibt im UI */ });
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md">
        <div className="w-12 h-12 rounded-full bg-teal-light text-teal flex items-center justify-center text-xl mx-auto mb-4 animate-pulse">⟳</div>
        <div className="text-[14px] text-gray-500">Dein Tracking wird geladen …</div>
        <div className="text-[12px] text-gray-400 mt-2">
          Falls du diesen Screen lange siehst, ist für deinen Account noch kein Tracking freigeschaltet.
          Melde dich beim Team.
        </div>
      </div>
    </div>
  );
}
